(ns ycweb.weber.form
  (:require
    [rum.core :as rum]
    [ycweb.util.core :as u]
    #?@(:clj
        [[ring.middleware.anti-forgery :as anti-forgery]])))

(def input-sizes #{"small" "medium" "long"})

(rum/defc hidden [name id value]
  [:input {:type "hidden" :name name :id id :value value}])

(rum/defc input
  [size name id & [value {:keys [autofocus classes autocomplete acvalue placeholder] :as opts}]]
  (let [result
        [:input.smallinput
         (merge
           (u/maybe assoc
             {:type "text"
              :name name
              :id id
              :value value
              :class
              (apply u/glue " "
                (concat
                  [size
                   "input"
                   (when autocomplete "googautocomplete")]
                  classes))}
             :autofocus autofocus
             :autocomplete (when autocomplete "off")
             :placeholder placeholder)
           (if autocomplete
             {:data-ac autocomplete
              :data-id (str "id_" id)}))]]

    (if autocomplete
      [:div
       result
       [:input
        {:type "hidden" :name (str "id_" name) :id (str "id_" id) :value acvalue
         :autocomplete "off"}]]

      result)))

(rum/defc textarea
  [name id value & {:keys [charcount rich rows]}]
  [:textarea.longinput.textarea
   {:name name :id id :rows (or rows 80)
    :class (str (str "longinput" (if charcount " charcount")))
    :type "text" :charcount charcount
    :value value}])

(defn option [text & [value]]
  {:text text :value (or value text)})

(rum/defc select-option [text & [value selected]]
  [:option
   (u/maybe assoc
     {:value (or value text)}
     :selected (when selected "selected"))
   text])

(defn map-select-options [options & [selected]]
  (map
    (fn [{n :text v :value}]
      (select-option n v (if (coll? selected) (contains? selected v) (= selected v)))) options))

(rum/defc select
  [name id options & {:keys [disabled multi size search placeholder selected]}]
  (into
    [:select
     (u/maybe assoc
       {:name name :id id
        :class (if search "chzn-select" "uniformselect")}
       :disabled (when disabled "disabled")
       :multiple (when multi "multiple")
       :size (when size (str size))
       :style (if search {"width" "350px"})
       :tab-index (if search "2")
       :data-placeholder placeholder)]
    (map-select-options options selected)))

(rum/defc radio [name id value text & [checked disabled]]
  [:input
   (u/maybe assoc
     {:type :radio
      :name name
      :id id
      :value value}
     :checked (when checked :checked)
     :disabled (when disabled :disabled))
   (str "   " text) [:br]])

(rum/defc checkbox
  [name id value text & [checked disabled]]
  (let [result
        [:input
         (u/maybe assoc
           {:name name :id id :value (if value "1")
            :type "checkbox"}
           :checked (when checked "checked")
           :disabled (when disabled "disabled"))]]
    (if text
      [:div result (str text "   ") [:br]])))

(rum/defc fileupload
  [name id & [value]]
  [:input
   {:name name :id id :value value
    :type "file"}])

(rum/defc tags [name id & [value]]
  [:input#tags.tags.longinput
   {:name name
    :value value
    :id id}])

(rum/defc spinner [name id value & {:keys [min max increment]}]
  [:input#spinner.spinner.width100.noradiusright
   {:type "text"
    :id id
    :value value
    :name name
    :data-min (or min 0)
    :data-max (or max 100)
    :data-increment (or increment 2)}])

(rum/defc submit [submit-text & [reset-text]]
  [:p#submitp.stdformbutton
   [:button.submit.radius2 submit-text]
   (when reset-text
     [:input.reset.radius2 {:type "reset" :value reset-text}])])

(rum/defc field [label element & [desc]]
  [:div.par
   [:label label]
   [:div.field (if (u/presence element) element "N/A")]
   (when desc
     [:small.desc desc])])

(rum/defc cleanform
  [action content & [{:keys [fileupload http-method content-type confirmation-message]}]]
  (into
    [:form.stdform
     (u/maybe assoc
       {:action action
        :method (or http-method "post")
        :accept content-type}
       :enctype (when fileupload "multipart/form-data")
       :data-requires-confirmation (when confirmation-message confirmation-message))
     #?(:clj [:input {:type "hidden" :name "__anti-forgery-token" :value (force anti-forgery/*anti-forgery-token*)}])]
    content))

(rum/defc grayform
  [action content & [{:keys [fileupload http-method confirmation-message]}]]
  (into
    [:form.stdform.stdform2
     (u/maybe assoc
       {:action action
        :method (or http-method "post")}
       :enctype (when fileupload "multipart/form-data")
       :data-requires-confirmation confirmation-message)
     #?(:clj [:input {:type "hidden" :name "__anti-forgery-token" :value (force anti-forgery/*anti-forgery-token*)}])]
    content))

(rum/defc plainform
  [action content & [{:keys [fileupload http-method content-type confirmation-message]}]]
  (into
    [:form
     (u/maybe assoc
       {:action action
        :method (or http-method "post")
        :accept content-type}
       :enctype (when fileupload "multipart/form-data")
       :data-requires-confirmation (when confirmation-message confirmation-message))
     #?(:clj [:input {:type "hidden" :name "__anti-forgery-token" :value (force anti-forgery/*anti-forgery-token*)}])]
    content))